import * as angular from "angular";
import { Column } from "../models/column.model";
import {
    TitleToRoleConfiguration, Role, JobFunction, DistrictZone,
    DefaultConfiguration, KeywordConfiguration
} from "../models/title-to-role-configuration.model";
import {ConfigurationService} from "../services/configuration/configuration.service";
import {RuleConfigCommand} from "../models/command/rule-config-command.model";
import { LinkPathService } from "../link-path/link-path.service";
import { StaffTestImportService } from "../services/staff-test-import/staff-test-import.service";

const DEFAULT_DISTRICT_RULE: DefaultConfiguration = {
    ruleTitle: "DISTRICT Default Settings",
    ruleType: "DISTRICT"
};
const DEFAULT_SCHOOL_RULE: DefaultConfiguration = {
    ruleTitle: "SCHOOL Default Settings",
    ruleType: "SCHOOL"
};

interface KeywordLists {
    SCHOOL: string[];
    DISTRICT: string[];
}

export class StaffRolesController {
    isSaveInProgress: boolean;
    columns: Column[];
    rows; // TODO: Add type annotation
    titleToRoleConfiguration: TitleToRoleConfiguration;
    keyword: string;
    schoolDefaultConfiguration: DefaultConfiguration;
    districtDefaultConfiguration: DefaultConfiguration;
    tagTextInputId: number;
    validSave: boolean = true;
    defaultsEditedFully: boolean = true;
    keywordTooltipId: number;
    newRole: KeywordConfiguration;
    newRoleKeywords: string;
    selectedSchoolRoles = Object.create(null);
    skippedSchoolRoles: Role[] = [];
    selectedDistrictRoles = Object.create(null);
    skippedDistrictRoles: Role[] = [];
    keywordTooltipMessage: string;
    keywordLists: KeywordLists = {
        SCHOOL: [],
        DISTRICT: []
    };
    newRoleRowAlert: string;
    newRoleKeywordError: string;
    isInitialUse: boolean;

    /* @ngInject */
    constructor(
                private $routeParams: { districtId: string },
                private configurationService: ConfigurationService,
                private $document: angular.IDocumentService,
                private $location: angular.ILocationService,
                private linkPathService: LinkPathService,
                private $q: angular.IQService,
                private staffTestImportService: StaffTestImportService,
                private $timeout: angular.ITimeoutService
            ) {}

    $onInit() {
        this.columns = [
            {headerName: "Clever Title Contains Keywords", field: "", cellRenderer: this.renderKeywordsHtml,
                width: 300, suppressSorting: true, cellClass: "role-drawer__keyword-column"},
            {
                headerName: "Type",
                headerCellRenderer: this.renderTypeHeaderHtml,
                field: "",
                cellRenderer: this.renderRuleTypeHtml,
                width: 70,
                suppressSorting: true
             },
            {headerName: "Function", field: "", cellRenderer: this.renderJobFunctionDropdown, width: 150, suppressSorting: true },
            {headerName: "Naviance Role", field: "", cellRenderer: this.renderNavianceRolesDropdown, width: 150, suppressSorting: true },
            {
                headerName: "Restriction and Lists",
                headerCellRenderer: this.renderRestrictionsHeaderHtml,
                field: "",
                cellRenderer: this.renderCheckboxesOrZonesHtml,
                width: 320,
                suppressSorting: true
            },
            {headerName: "", field: "", cellRenderer: this.renderDeleteButton, suppressSorting: true }
        ];

        this.isInitialUse = this.$location.search().initial;

        this.configurationService.getTitleToRoleConfiguration(this.$routeParams.districtId)
            .then(titleToRoleConfig => {
                this.titleToRoleConfiguration = titleToRoleConfig;
               
                this.initSkippedRoles();
                this.rows = this.getCustomRules();
                this.initDefaultConfigurations();
            });
    }

    

    private initSkippedRoles() {
        if (!this.titleToRoleConfiguration) { return; }
        
        const skippedConfigs = this.titleToRoleConfiguration.skippedConfigurations;
        if (skippedConfigs && skippedConfigs.length) {

            const districtConfig = skippedConfigs.filter(c => c.ruleType === "DISTRICT")[0];

            if (districtConfig) {
                districtConfig.roles.forEach(role => {
                    this.selectedDistrictRoles[role.roleId] = true;
                    this.skippedDistrictRoles.push(role);
                });
            }
            
            const schoolConfig = skippedConfigs.filter(c => c.ruleType === "SCHOOL")[0];

            if (schoolConfig) {
                schoolConfig.roles.forEach(role => {
                    this.selectedSchoolRoles[role.roleId] = true;
                    this.skippedSchoolRoles.push(role);
                });
            }
        } else if (!this.titleToRoleConfiguration.updated) {
            let districtSiteManager = this.titleToRoleConfiguration.districtRoles.filter(r => r.roleName === "District Site Manager")[0];
            if (districtSiteManager) {
                this.selectedDistrictRoles[districtSiteManager.roleId] = true;
                this.skippedDistrictRoles.push(districtSiteManager);
            }
        }
    }

    getCustomRules() {
        if (this.titleToRoleConfiguration && this.titleToRoleConfiguration.keywordConfigurations &&
            this.titleToRoleConfiguration.keywordConfigurations.length > 0) {
            return this.titleToRoleConfiguration.keywordConfigurations;
        }
        return [{
                    keywords: ["Couns"],
                    ruleType: "SCHOOL",
                    lists: {
                        teacher: false,
                        counselor: true
                    }
                },
                {
                    keywords: ["Teacher", "Tchr"],
                    ruleType: "SCHOOL",
                    lists: {
                        teacher: true,
                        counselor: false
                    }
                }
            ];
    }

    /* istanbul ignore next */
    private renderKeywordsHtml = (params) => {
        params.$scope.vm = this;
        return `
            <div class="ns-grid ns-grid--fluid ns-grid--fluid--hugged role-drawer__keywords">
                <div class="ns-grid__row ns-grid__row--sm-start ">
                    <div class="ns-grid__col" ng-repeat="keyword in data.keywords | limitTo : 4 as results">
                        <button class="ns-tag ns-tag--removeable">
                            {{ keyword }}
                            <i class="ns-icon ns-icon--size-large ns-icon--cancel"
                                ng-click="vm.removeKeyword(data, keyword, rowNode.id)"></i>
                        </button>
                        <div
                            class="
                                ns-tooltip
                                ns-tooltip--right
                                ns-tooltip--dynamic-width
                                role-drawer__tooltip
                                role-drawer__tooltip--danger
                            "
                            ng-if="vm.showKeywordTooltip(rowNode.id)"
                        >
                            <span class="ns-tooltip__icon ns-icon ns-icon--flag"></span>
                            <span class="ns-icon ns-icon--cancel ns-alert__close ns-alert--danger__close"
                                ng-click="vm.closeKeywordTooltip()"></span>
                            <div class="ns-tooltip__content">
                                At least 1 keyword is required.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <p class="keyword-hint" ng-click="vm.showKeywordInput(rowNode.id)"
                ng-if="!vm.shouldShowKeywordInput(rowNode.id)">Add Title Keyword</p>
            <form class="ns-form" ng-submit="vm.addKeyword(data, vm.keyword, rowNode.id)">
                <input type="text" class="ns-textbox role-drawer__keyword-textbox" name="keyword" ng-model="vm.keyword"
                placeholder="Type new keyword here..." ng-if="vm.shouldShowKeywordInput(rowNode.id)">
                <button class="ns-button ns-button--primary role-drawer__check-button" ng-if="vm.shouldShowKeywordInput(rowNode.id)"
                    ng-submit="vm.addKeyword(data, vm.keyword, rowNode.id)"
                    ><i class="ns-icon ns-icon--check"></i></button>
                <div class="ns-tooltip ns-tooltip--right ns-tooltip--dynamic-width
                    role-drawer__tooltip role-drawer__tooltip--left-margin role-drawer__tooltip--danger"
                    ng-if="vm.shouldShowKeywordFlag(data, rowNode.id)"
                >
                    <span class="ns-tooltip__icon ns-icon ns-icon--flag"></span>
                    <span class="ns-icon ns-icon--cancel ns-alert__close ns-alert--danger__close" ng-click="vm.closeInputTooltip()"></span>
                    <div class="ns-tooltip__content">
                        {{ vm.keywordTooltipMessage }}
                    </div>
                </div>
            </form>
        `;

    }

    /* istanbul ignore next */
    private renderRuleTypeHtml = (params) => {
        params.$scope.vm = this;
        return `{{data.ruleType.charAt(0).toUpperCase() + data.ruleType.slice(1).toLowerCase()}}`;
    }

    /* istanbul ignore next */
    private renderTypeHeaderHtml = (params) => {
        params.$scope.vm = this;
        return `
            Type
            <i
                class="ns-icon ns-icon--help-sign ns-icon--color-primary ns-icon--size-large"
                ng-click="vm.toggleTypeColumnTooltipStyle($event)"
            ></i> 
        `;
    }

    /* istanbul ignore next */
    private renderRestrictionsHeaderHtml = (params) => {
        params.$scope.vm = this;
        return `
            Restriction and Lists
            <i
                class="ns-icon ns-icon--help-sign ns-icon--color-primary ns-icon--size-large"
                ng-click="vm.toggleRestrictionColumnTooltipStyle($event)"
            ></i> 
        `;
    }

    typeColumnTooltipStyle: { [key: string]: any } = {
        visibility: "hidden"
    };

    /* istanbul ignore next */
    getToggledTooltipStyle(currentStyle: { [key: string]: any }, event: MouseEvent, tooltipHeight: number) {
        if (currentStyle.visibility === "hidden") {
            const targetRect = event.srcElement.getBoundingClientRect();
            const targetCenter = targetRect.left - (targetRect.width / 2);
            
            const targetTop = targetRect.top + window.scrollY;
            const tooltipTop = targetTop - tooltipHeight;

            return {
                top: `calc(${tooltipTop}px - 1rem)`,
                left: `calc(${targetCenter}px - 12.5rem)`
            };
        }
        
        return {
            visibility: "hidden"
        };
    }

    /* istanbul ignore next */
    toggleTypeColumnTooltipStyle(event: MouseEvent) {
        const height = document.getElementById("type-column-tooltip").clientHeight;
        this.typeColumnTooltipStyle = this.getToggledTooltipStyle(this.typeColumnTooltipStyle, event, height);
    }

    restrictionColumnTooltipStyle: { [key: string]: any } = {
        visibility: "hidden"
    };

    /* istanbul ignore next */
    toggleRestrictionColumnTooltipStyle(event: MouseEvent) {
        const height = document.getElementById("restriction-column-tooltip").clientHeight;
        this.restrictionColumnTooltipStyle = this.getToggledTooltipStyle(this.restrictionColumnTooltipStyle, event, height);
    }

    /* istanbul ignore next */
    private renderJobFunctionDropdown = (params) => {
        params.$scope.vm = this;
        return `
        <div ng-class="{'role-drawer__select': vm.shouldHighlight(data.jobFunction)}">
            <select class="ns-select ns-select--full-bleed"
                ng-options="jobFunction.jobFunctionTitle for jobFunction in vm.getJobFunctions(data.ruleType)
                    track by jobFunction.jobFunctionId"
                ng-model="data.jobFunction">
                <option value="" disabled hidden>Function</option>
            </select>
        </div>
        <div class="role-drawer__sub-text" ng-if="vm.shouldHighlight(data.jobFunction)"><strong>Function required</strong></div>
        `;
    }

    /* istanbul ignore next */
    private renderNavianceRolesDropdown = (params) => {
        params.$scope.vm = this;
        return `
            <div ng-class="{'role-drawer__select': vm.shouldHighlight(data.role)}">
                <select class="ns-select ns-select--full-bleed"
                    ng-options="role.roleName for role in vm.getRoles(data.ruleType) track by role.roleId"
                    ng-model="data.role">
                    <option value="" disabled hidden>Role</option>
                </select>
            </div>
            <div class="role-drawer__sub-text" ng-if="vm.shouldHighlight(data.role)"><strong>Role required</strong></div>
        `;
    }

    /* istanbul ignore next */
    private renderCheckboxesOrZonesHtml = (params) => {
        params.$scope.vm = this;
        if (params.data.ruleType === "SCHOOL") {
            return `
                <div>
                    <label class="ns-label ns-label--inline ns-label--light">
                        <input class="ns-checkbox" type="checkbox" ng-model="data.lists.teacher" />
                        Teacher List
                    </label>
                    <label class="ns-label ns-label--inline ns-label--light">
                        <input class="ns-checkbox" type="checkbox" ng-model="data.lists.counselor" />
                        Counselor List
                    </label>
                </div>
            `;
        }
        return `
            <div ng-class="{'role-drawer__select': vm.shouldHighlight(data.zone)}">
                <select class="ns-select ns-select--full-bleed"
                    ng-options="districtZone.title for districtZone in vm.getDistrictZones() track by districtZone.id"
                    ng-model="data.zone">
                    <option value="" disabled hidden>Zone Restrictions</option>
                </select>
            </div>
            <div class="role-drawer__sub-text" ng-if="vm.shouldHighlight(data.zone)"><strong>Zone required</strong></div>
        `;
    }

    /* istanbul ignore next */
    private renderDeleteButton = (params) => {
        params.$scope.vm = this;
        return `<button class="ns-button ns-button--danger" ng-click="vm.deleteRoleRow(rowNode.id)"
                    >Delete</button>`;
    }

    showKeywordInput(id: number) {
        this.keyword = "";
        this.tagTextInputId = id;
    }

    addKeyword(data, keyword, id) {
        this.keywordTooltipId = -1;

        const newKeywords = this.keywordTrimmerAndSplitter(keyword);
        this.keywordTooltipMessage = this.getKeywordInputTooltipMessage(data, id);
        let tempKeywords = this.keywordTrimmerAndSplitter(keyword.toLowerCase());

        if (this.isValidKeywordInsert(data, id)) {
            this.keyword = "";
            this.keywordLists[data.ruleType] = [...this.keywordLists[data.ruleType], ...tempKeywords];
            data.keywords = [...data.keywords, ...newKeywords];
        }
    }

    removeKeyword(data, keyword, id) {
        const keywords = data.keywords;
        const index = keywords.indexOf(keyword);

        if (index > -1 && this.keywordRemovable(keywords)) {
            this.keywordLists[data.ruleType].splice(index, 1);
            keywords.splice(index, 1);
        } else {
            this.keywordTooltipId = id;
        }
    }

    keywordRemovable(keywords: string[]) {
        return keywords.length > 1;
    }

    showKeywordTooltip(id) {
        return this.keywordTooltipId === id;
    }

    closeKeywordTooltip() {
        this.keywordTooltipId = -1;
    }

    closeInputTooltip() {
        this.tagTextInputId = -1;
    }

    isValidKeywordInsert(data, id) {
        if (!this.keyword) {
            return false;
        }
        const newKeywords = this.keywordTrimmerAndSplitter(this.keyword);
        return this.tagTextInputId === id &&
            !(this.areDuplicateKeywords(newKeywords, data.ruleType) || !this.isValidKeyword(id, newKeywords) ||
                this.isMaximumKeywordLimitReached(data.keywords.length, newKeywords.length));
    }

    shouldShowKeywordFlag(data, id) {
        if (this.keywordTooltipMessage) {
            this.keywordTooltipMessage = this.getKeywordInputTooltipMessage(data, id);
        }
        return !!this.keywordTooltipMessage && this.shouldShowKeywordInput(id) && !this.isValidKeywordInsert(data, id);
    }

    getKeywordInputTooltipMessage(data, id) {
        if (!this.keyword) {
            return undefined;
        }
        const newKeywords = this.keywordTrimmerAndSplitter(this.keyword);
        if (this.isMaximumKeywordLimitReached(data.keywords.length, newKeywords.length)) {
            return "You have reached the max of 4 keywords per row.";
        }

        if (!this.isValidKeyword(id, newKeywords)) {
            return "Keywords must be between 3-20 characters.";
        }

        if (this.areDuplicateKeywords(newKeywords, data.ruleType)) {
            return "One or more of your keywords is already in use. Please remove duplicate keywords.";
        }
        return " ";
    }

    areDuplicateKeywords(newKeywords: string[], ruleType) {
        if (this.keywordLists.SCHOOL.length === 0 || this.keywordLists.DISTRICT.length === 0) {
            this.keywordLists.SCHOOL = this.rows
                .filter(r => r.ruleType === "SCHOOL")
                .map(r => r.keywords)
                .reduce((prevKeywords, keywords) => [...prevKeywords, ...keywords], [])
                .map(x => x.toLowerCase());
            this.keywordLists.DISTRICT = this.rows
                .filter(r => r.ruleType === "DISTRICT")
                .map(r => r.keywords)
                .reduce((prevKeywords, keywords) => [...prevKeywords, ...keywords], [])
                .map(function(x){ return x.toLowerCase(); })
                .map(x => x.toLowerCase());
        }

        return newKeywords.some(keyword => this.keywordLists[ruleType].indexOf(keyword.toLowerCase()) > -1);     
    }

    isValidKeyword(id, keywords) {
        keywords.sort(function (a, b) { return b.length - a.length; });

        return this.tagTextInputId === id && !(keywords[0].length > 20 || keywords[keywords.length - 1].length < 3);
    }

    isMaximumKeywordLimitReached(keywordsInRowLength: number, newKeywordsLength: number): boolean {
        return keywordsInRowLength + newKeywordsLength > 4;
    }

    closePage() {
        this.rows = this.getCustomRules();
        this.resetDefaultConfigurations();

        this.linkPathService.getStaffTabPath();

        this.$location.path(`${this.$routeParams.districtId}/${this.linkPathService.getStaffTabPath()}`);
    }

    private saveSettingsAnd(promiseMaker: () => angular.IPromise<any>): angular.IPromise<any> {
        this.validSave = this.validateBeforeSave();
        if (this.validSave) {
            this.isSaveInProgress = true;
            return this.configurationService.saveTitleToRoleConfiguration(this.constructRuleConfigCommand())
                .then(() => promiseMaker())
                .then(() => {
                    this.closePage();
                });
        } else if (!this.defaultsEditedFully) {
            this.$document[0].getElementById("top").scrollIntoView();
        }
    }

    saveSettings() {
        const doNothing = () => this.$q.resolve();
        this.saveSettingsAnd(doNothing);
    }

    saveAndBeginTestImport() {
        const startTestImport = (): angular.IPromise<any> => this.staffTestImportService
            .staffTestImport(this.$routeParams.districtId)
            .then(() => this.pollTillTestImportIsInProgress(this.$routeParams.districtId));
            
        this.saveSettingsAnd(startTestImport);
    }

    pollTillTestImportIsInProgress(districtId: string): angular.IPromise<any> {
        return this.staffTestImportService.getStaffTestImportStatus(districtId).then(status => {
            return status.startedOn
                ? this.$q.resolve()
                : this.$timeout(333).then(() => this.pollTillTestImportIsInProgress(districtId));
        });
    }

    validateBeforeSave(): boolean {
        this.defaultsEditedFully = true;
        const validTable:boolean = this.rows.every(row =>
            (row.jobFunction && row.role) || (row.ruleType === "DISTRICT" && row.zone));

        if (!(this.districtDefaultConfiguration.jobFunction && this.districtDefaultConfiguration.role
            && this.schoolDefaultConfiguration.jobFunction && this.schoolDefaultConfiguration.role
            && this.districtDefaultConfiguration.zone)) {
                this.defaultsEditedFully = false;
        }

        return validTable && this.defaultsEditedFully;
    }

    getRoles(type: string): Role[] {
        if (!this.titleToRoleConfiguration) { return; }
        if (type === "SCHOOL") {
            return this.titleToRoleConfiguration.schoolRoles;
        }
        return this.titleToRoleConfiguration.districtRoles;
    }

    getJobFunctions(type: string): JobFunction[] {
        if (!this.titleToRoleConfiguration) { return; }
        if (type === "SCHOOL") {
            return this.titleToRoleConfiguration.schoolJobFunctions;
        }
        return this.titleToRoleConfiguration.districtJobFunctions;
    }

    getDistrictZones(): DistrictZone[] {
        if (!this.titleToRoleConfiguration) { return; }

        return this.titleToRoleConfiguration.zones;
    }

    private constructRuleConfigCommand(): RuleConfigCommand {
        const getRoleName = (r: Role) => r.roleName;
        return {
            districtId: this.$routeParams.districtId,
            defaultConfigurations: [this.schoolDefaultConfiguration, this.districtDefaultConfiguration],
            keywordConfigurations: this.rows,
            rolesToSkip: {
                districtRoles: {
                    roleNames: this.skippedDistrictRoles.map(getRoleName)
                },
                schoolRoles: {
                    roleNames: this.skippedSchoolRoles.map(getRoleName)
                }
            }
        };
    }

    getSchoolDefaultConfiguration(): DefaultConfiguration {
        if (!this.titleToRoleConfiguration || !this.titleToRoleConfiguration.defaultConfigurations) {
            return angular.copy(DEFAULT_SCHOOL_RULE); }

        return this.getDefaultConfiguration(DEFAULT_SCHOOL_RULE);
    }

    getDistrictDefaultConfiguration(): DefaultConfiguration {
        if (!this.titleToRoleConfiguration || !this.titleToRoleConfiguration.defaultConfigurations) {
            return angular.copy(DEFAULT_DISTRICT_RULE); }

        return this.getDefaultConfiguration(DEFAULT_DISTRICT_RULE);
    }

    private getDefaultConfiguration(rule: DefaultConfiguration): DefaultConfiguration {
        const defaultConfigurations = this.titleToRoleConfiguration.defaultConfigurations.filter(
            defaultConfiguration => defaultConfiguration.ruleType === rule.ruleType);

        return defaultConfigurations.length === 1 ? defaultConfigurations[0] : angular.copy(rule);
    }

    private initDefaultConfigurations() {
        this.schoolDefaultConfiguration = this.getSchoolDefaultConfiguration();
        this.districtDefaultConfiguration = this.getDistrictDefaultConfiguration();
    }

    private resetDefaultConfigurations() {
        this.initDefaultConfigurations();
    }

    shouldShowKeywordInput(id: number) {
        return id === this.tagTextInputId;
    }

    shouldHighlight(data) {
        return !data && !this.validSave;
    }

    shouldHighlightNewRole(data) {
        return !data && this.newRoleRowAlert;
    }

    addNewRoleRow() {
        this.validateNewRoleRow();
        if (!this.newRoleRowAlert) {
            this.newRole.keywords = this.keywordTrimmerAndSplitter(this.newRoleKeywords);
            let tempKeywords = this.keywordTrimmerAndSplitter(this.newRoleKeywords.toLowerCase());
            this.keywordLists[this.newRole.ruleType] = 
                [...this.keywordLists[this.newRole.ruleType], ...tempKeywords];
            this.rows.push(angular.copy(this.newRole));
            this.newRole = undefined;
            this.newRoleKeywords = "";
        }
    }

    validateNewRoleRow():void {
        if (!this.newRoleKeywords) {
            this.newRoleRowAlert = "The highlighted fields are required. Please complete these before adding.";
            this.newRoleKeywordError = "At least 1 Keyword is required";
            return;
        }
        let keywords = this.keywordTrimmerAndSplitter(this.newRoleKeywords);
        keywords.sort(function (a, b) { return b.length - a.length; });
        if (keywords[0].length > 20 || keywords[keywords.length - 1].length < 3) {
            this.newRoleRowAlert = "Keywords must be between 3-20 characters. Please update your keywords to meet these requirements.";
            this.newRoleKeywordError = "Keyword is too long/short";
            return;
        } else if (!this.newRole || !this.newRole.ruleType 
            || (this.newRole.ruleType === "SCHOOL" && (!this.newRole.jobFunction || !this.newRole.role))
            ||(this.newRole.ruleType === "DISTRICT" && !this.newRole.zone)) {
            this.newRoleRowAlert = "The highlighted fields are required. Please complete these before adding.";
            this.newRoleKeywordError = undefined;
            return;
        }
        if (this.areDuplicateKeywords(keywords, this.newRole.ruleType)) {
            this.newRoleRowAlert = "One or more of your keywords is already in use. Please choose a different keyword.";
            this.newRoleKeywordError = "Keyword already in use";
            return;
        }

        this.newRoleRowAlert = undefined;
        this.newRoleKeywordError = undefined;
    }

    deleteRoleRow(rowId: number) {
        this.rows.splice(rowId, 1);
    }

    keywordTrimmerAndSplitter(originalString: string = ""):string[] {
        return originalString.split(",").map(keyword => keyword.trim());
    }

    private getUpdatedSkippedRoles(skipped: Role[], selectedRole: Role): Role[] {
        return skipped.some(r => selectedRole.roleId === r.roleId)
            ? skipped.filter(r => selectedRole.roleId !== r.roleId)
            : [...skipped, selectedRole];
    }

    toggleSkippingSchoolRole(role: Role) {
        this.skippedSchoolRoles = this.getUpdatedSkippedRoles(this.skippedSchoolRoles, role);
    }

    toggleSkippingDistrictRole(role: Role) {
        this.skippedDistrictRoles = this.getUpdatedSkippedRoles(this.skippedDistrictRoles, role);
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/staff-roles/staff-roles.controller.ts